import { toolFetch } from "../Utils/toolUsage";
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FiArrowRight, FiBarChart2, FiCheck, FiLink, FiGlobe, FiExternalLink, FiFileText, FiShield, FiAlertTriangle, FiCalendar, FiClock, FiRefreshCw } from "react-icons/fi";
import authorityArt from "../Images/domain-tools/authority.png";
import ageArt from "../Images/domain-tools/age.png";
import authorityIcon from "../Images/domain-tools/authority-icon.png";
import ageIcon from "../Images/domain-tools/age-icon.png";
import "./Dapa.css";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { basicauth } from "../Utils/Credentials";

const resultDate = value => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit" });
};

function MetricResult({ title, value, tone, description, icon: Icon }) {
  const parsed = value == null || String(value).trim() === "" ? NaN : Number(String(value).replace(/%$/, ""));
  const score = Number.isFinite(parsed) && parsed >= 0 && parsed <= 100 ? parsed : null;
  const level = score === null ? "Unavailable" : score < 30 ? "Low" : score < 50 ? "Moderate" : "High";
  const badge = score === null ? "Data unavailable" : `${level} ${tone === "spam" ? "Spam Risk" : "Authority"}`;
  return <article className={`domain-result-metric domain-result-${tone}`}>
    <div className="domain-result-gauge" role="img" aria-label={`${title}: ${score === null ? "unavailable" : `${score}%`}`}>
      <svg viewBox="0 0 120 120" aria-hidden="true"><circle className="domain-gauge-track" cx="60" cy="60" r="50" /><circle className="domain-gauge-value" cx="60" cy="60" r="50" pathLength="100" strokeDasharray={`${score ?? 0} 100`} /></svg>
      <strong>{score === null ? "—" : `${score}%`}</strong>
    </div>
    <div className="domain-result-metric-copy"><h4>{title}</h4><p>{description}</p><span className="domain-result-badge" title="Display ranges: low below 30, moderate 30–49, high 50–100. These are presentation bands, not a provider classification.">{tone === "spam" ? <FiAlertTriangle aria-hidden="true" /> : <FiBarChart2 aria-hidden="true" />}{badge}</span></div>
    <span className="domain-result-metric-icon"><Icon aria-hidden="true" /></span>
  </article>;
}

const Domainpage = () => {
  const [url, setUrl] = useState(() => new URLSearchParams(window.location.search).get("url") || "");
  const [url1, setUrl1] = useState("");
  const [loading, setLoading] = useState(false);
  const formatDomainInput = (input) => {
    input = input.trim();
    if (!input.startsWith("https://") && !input.startsWith("http://")) {
      return `https://${input}`;
    }
    return input;
  };
  const [seoData1, setSeoData1] = useState(null);
  const [seoData, setSeoData] = useState(null);
  const fetchData = async () => {
    setLoading(true);
    const formattedUrl = formatDomainInput(url);

    try {
      const response = await toolFetch(

        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/GetDomainAge`,
       {
          method: "POST",
         headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ domainName: formattedUrl, type: "1" }),
        }
      );

      const data = await response.json();
      setSeoData(data.data[0]);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching domain data:", error);
    } finally {
      setLoading(false);
    }
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const fetchData1 = async () => {
    const uuid = generateUUID();
    const formattedUrl = formatDomainInput(url1);

    setLoading(true);
    try {
      const response = await toolFetch(
       `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchSiteMetrics`,
        {
          method: "POST",
         headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formattedUrl,
            scope: "domain",
            type: "1",
          }),
        }
      );

      const data = await response.json();
      if (
        data.status === "0" &&
        data.msg === "Success" &&
        data.data.length > 0
      ) {
        setSeoData1(data.data[0]);
        setLoading(false);
      } else {
        console.log("Site metrics not found in response");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching domain data:", error);
      setLoading(false);
    }
  };

  const checkers = [
    { key: "authority", title: "Domain Authority Checker", description: "Quickly analyze a domain’s authority, page strength, keyword rankings, and leading competitors in just one click.", art: authorityArt, icon: authorityIcon, value: url1, setValue: setUrl1, submit: fetchData1, benefits: ["Domain Authority", "Page Strength", "Top Competitors"] },
    { key: "age", title: "Domain Age Checker", description: "Domain age checker can help you determine a website’s history within seconds. Just enter the URL to quickly find out how long a site has been online and assess its reliability!", art: ageArt, icon: ageIcon, value: url, setValue: setUrl, submit: fetchData, benefits: ["Domain Registration Date", "Domain Age", "Trust & Reliability"] },
  ];

  return (
    <section className="domain-tools" aria-labelledby="domain-tools-title" aria-busy={loading}>
      <header className="domain-tools-heading">
        <span className="domain-tools-eyebrow"><FiBarChart2 aria-hidden="true" /> FREE SEO TOOLS</span>
        <h2 id="domain-tools-title">Check Your <span>Domain Authority</span> and <span>Age</span> Instantly</h2>
        <p>Get instant insights about any website’s authority, history, and performance with our free SEO tools.<br />Just enter a domain and check within seconds.</p>
      </header>
      <div className="domain-tools-note" aria-hidden="true">Free<br />SEO Tools<svg viewBox="0 0 70 65"><path d="M50 5Q62 35 20 54M20 54L27 39M20 54L37 54" /></svg></div>
      <div className="domain-tools-grid">
        {checkers.map(checker => (
          <article className={`domain-tool-card domain-tool-${checker.key}`} key={checker.key}>
            <div className="domain-tool-intro">
              <img className="domain-tool-icon" src={checker.icon} alt="" />
              <div className="domain-tool-copy"><h3>{checker.title}</h3><p>{checker.description}</p></div>
              <img className="domain-tool-art" src={checker.art} alt="" loading="lazy" decoding="async" />
            </div>
            <form className="domain-tool-form" onSubmit={event => { event.preventDefault(); if (checker.value.trim()) checker.submit(); }}>
              <label className="domain-tool-input"><FiLink aria-hidden="true" /><input type="text" required aria-label={`Domain for ${checker.title}`} placeholder="Enter Domain (e.g. example.com)" value={checker.value} onChange={event => checker.setValue(event.target.value)} /></label>
              <button type="submit" disabled={loading}>{loading ? "Checking…" : "Check for free"}<FiArrowRight aria-hidden="true" /></button>
            </form>
            <ul className="domain-tool-benefits">{checker.benefits.map(benefit => <li key={benefit}><FiCheck aria-hidden="true" />{benefit}</li>)}</ul>
          </article>
        ))}
      </div>
      {loading && <p className="domain-tools-status" role="status">Checking domain information…</p>}
      <div className="domain-tools-results" aria-live="polite">
        {seoData1 && (
          <section className="domain-result-panel" aria-labelledby="domain-metrics-title">
            <header className="domain-result-header">
              <span className="domain-result-header-icon"><FiGlobe aria-hidden="true" /></span>
              <div><h3 id="domain-metrics-title">Domain Information for <span>{seoData1.url}</span></h3><p>See key authority metrics to understand the strength and trust of this domain.</p></div>
              <span className="domain-result-tip"><FiExternalLink aria-hidden="true" />Get insights. Make better SEO decisions.</span>
            </header>
            <div className="domain-result-metrics">
              <MetricResult title="Domain Authority (DA)" value={seoData1.da} tone="authority" icon={FiBarChart2} description="A higher DA indicates a stronger and more trusted domain." />
              <MetricResult title="Page Authority (PA)" value={seoData1.pa} tone="page" icon={FiFileText} description="A higher PA means this page has more ranking potential." />
              <MetricResult title="Spam Score" value={seoData1.spam_score} tone="spam" icon={FiShield} description="A higher spam score indicates a higher risk of spam." />
            </div>
          </section>
        )}
        {seoData && (
          <section className="domain-result-panel domain-result-age" aria-labelledby="domain-age-result-title">
            <header className="domain-result-header">
              <span className="domain-result-header-icon"><FiCalendar aria-hidden="true" /></span>
              <div><h3 id="domain-age-result-title">Domain Age for <span>{seoData.domainName}</span></h3><p>Check when the domain was registered, last updated, and when it will expire.</p></div>
              <span className="domain-result-tip"><FiCalendar aria-hidden="true" />Keep track of your domain details<br />to plan your SEO strategy better.</span>
            </header>
            <div className="domain-result-dates">
              {[
                ["Domain Age", seoData.estimatedDomainAge || "—", FiClock, "age"],
                ["Created On", resultDate(seoData.createdDate), FiCalendar, "created"],
                ["Updated On", resultDate(seoData.updatedDate), FiRefreshCw, "updated"],
                ["Expire Date", resultDate(seoData.expiresDate), FiCalendar, "expires"],
              ].map(([label, value, Icon, tone]) => <div className={`domain-result-date domain-date-${tone}`} key={label}><span className="domain-date-icon"><Icon aria-hidden="true" /></span><div><h4>{label}</h4><p>{value}</p></div></div>)}
            </div>
          </section>
        )}
      </div>
    </section>
  );
};

export default Domainpage;
